import { render, staticRenderFns } from "./AssetInformationFileList.vue?vue&type=template&id=90d91e36&scoped=true&"
import script from "./AssetInformationFileList.vue?vue&type=script&lang=js&"
export * from "./AssetInformationFileList.vue?vue&type=script&lang=js&"
import style0 from "./AssetInformationFileList.vue?vue&type=style&index=0&id=90d91e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d91e36",
  null
  
)

export default component.exports